module.exports = __webpack_public_path__ + "assets/img/solar-panels-4.8d33eebe.jpg";